<template>
  <v-toolbar
    data-js="get-height"
    class="toolbar--white action-bar overflow--y get-height"
    :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    flat
  >
    <Breadcrumb :routes="breadcrumbItems" />

    <v-spacer />
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import Breadcrumb from 'components/Breadcrumb'

export default {
  name: 'ActionBar',
  components: {
    Breadcrumb
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen
    })
  },
  data () {
    return {
      namespace: 'Views.SearchPhonePage',
      breadcrumbItems: [
        { name: 'SearchPhonePage', title: this.$t('Views.SearchPhonePage.title') }
      ]
    }
  }
}
</script>
